import React, { Fragment } from "react";
import Container from "react-bootstrap/Container";
import "./TermsTab.css";

const TermsUse = (props) => {
  return (
    <Fragment>
      <div className="tc main-pad py-md-5 py-4">
        <h3> Disclaimer Clause </h3>
        <p>
          The information on this Website is provided on an “as is” basis. To
          the fullest extent permitted by law, Company excludes all
          representations and warranties relating to this Website and its
          contents or which is or may be provided by any affiliates or any other
          third party, including in relation to any inaccuracies or omissions in
          this Website and/or the Comany’s literature; and excludes all
          liability for damages arising out of or in connection with your use of
          this Website. This includes, without limitation, direct loss, loss of
          business or profits (whether or not the loss of such profits was
          foreseeable, arose in the normal course of things or you have advised
          Company of the possibility of such potential loss), damage caused to
          your computer, computer software, systems and programs and the data
          thereon or any other direct or indirect, consequential and incidental
          damages.
          <br />
          <br />
          The information/material provided on the website
          www.phoenixmarketcity.com is owned and managed by “The Phoenix Mills
          Ltd” (hereinafter referred to as “Phoenix Marketcity”) and is provided
          on an “as is” basis. Phoenix Marketcity expressly disclaims to the
          maximum limit permissible by law, all warranties, express or implied,
          including, but not limiting to implied warranties of merchantability,
          fitness for a particular purpose and non-infringement. Phoenix
          Marketcity disclaims all responsibility for any loss, injury,
          liability or damage of any kind resulting from and arising out of, or
          any way related to:
        </p>
        <ul>
          <li>
            Any errors in or omissions from the Website and its content,
            including but not limited to technical inaccuracies and
            typographical errors.
          </li>
          <li>
            Any third party Websites or content there in directly or indirectly
            accessed through links in the Site, including but not limited to any
            errors in or omissions there from.
          </li>
          <li>
            The unavailability of this Site or any portion thereof; your use of
            any equipment or software in connection with the Site.
          </li>
          <li>Your use of the Site.</li>
        </ul>
        <br />
        <br />
        <h3> Limitation of Liability </h3>
        <p>
          Under no circumstances shall Phoenix Marketcity be liable to any user
          for:{" "}
        </p>
        <ul>
          <li>
            {" "}
            Loss, injury, claim, liability or damages of any kind resulting from
            the use of or the inability to use the materials in the Website ,
            even if Phoenix Marketcity had been advised of the possibility of
            such damages and regardless of the form of action, whether in
            contract, tort or otherwise.
          </li>
          <li>
            Special, direct, incidental, punitive, exemplary or consequential
            damages of any kind whatsoever (including without limitation,
            attorney’s fees) in any way due, resulting from or arising in
            connection with the use of or the inability to use the Website or
            its content / materials.{" "}
          </li>
          <li>
            {" "}
            Claim attributable to errors, omission or inaccuracies in or
            destructive properties of any information.
          </li>
        </ul>
        <br />
        <br />
        <p>
          We are not responsible for any disputes or disagreements between you
          and any third party vendor or third party interface (including but not
          limited to the payment gateway vendor) you interact with using the
          Service. However, to the extent disputes between users arise in
          connection with the use of the Service. You assume all risk associated
          with dealing with third parties. You agree to resolve disputes
          directly with the other party. You release Company of all claims,
          demands, and damages in disputes among users of the Service You also
          agree not to involve Us in such disputes Use caution and common sense
          when using the Service in no event will Company be liable for any
          damages whatsoever, whether direct, indirect, general, special,
          exemplary, compensatory, consequential, and/or incidental, arising out
          of or relating to including, but not limited to, damages for loss of
          profits, goodwill, use, data or other intangible losses, resulting
          from: (i) the use or the inability to use the service; (ii) the cost
          of procurement of substitute goods and services resulting from any
          goods, data, information or services obtained or messages received or
          transactions entered into through, from, or as a result of the site;
          (iii) unauthorized access to or alteration of your transmissions or
          data; (iv) statements or conduct of any user or third party on the
          service; (v) your reliance on content or data made available by us;
          (vi) the conduct of you or anyone else in connection with the use of
          the service, including without limitation, bodily injury, emotional
          distress obtained through the services. Company expressly disclaims
          any liability whatsoever for any damage, suits, claims, and/or
          controversies that arise or related in any way to the services, the
          information provided through the services and the services provided by
          or to any user of the services.
          <br />
          <br />
          In no event will the Company, its officers, directors, employees or
          agents, be liable to you for any indirect, incidental, special,
          punitive or consequential damages of any kind arising out of or in
          connection with your use of the services and/or application, whether
          the damages are foreseeable and whether or not the Company has been
          advised of the possibility of such damages. In no event will Company’s
          cumulative liability to you, for all claims regardless of type, exceed
          _________. In addition, from time to time, various entities may
          sponsor reward points, offers and other rewards as part of a service
          (“sponsors”). You hereby waive and disclaim any and all liability
          claims against sponsors relating in any way to your use of the
          services or any such rewards. You agree that sponsors are third party
          beneficiaries of the terms, and may enforce its provisions directly.
        </p>
        <br />
        <br />
        <h3> No Liability </h3>
        <p>
          Phoenix Marketcity makes reasonable effort to ensure that the
          information provided on the Website is accurate but does not guarantee
          or warrant its accuracy, adequacy, correctness, validity, completeness
          or suitability for any purpose. Phoenix Marketcity accepts no
          responsibility with respect to the information on the Site. Use of
          this Site, by implication, means that you have gone through and agreed
          to abide by the Terms and Conditions and the Disclaimers on this site.
          Phoenix Marketcity does not represent that the information downloaded
          from this Website is completely error-free and accurate or the servers
          that make Phoenix Marketcity website available, are free of viruses or
          harmful components. Though due care has been taken to make the
          database completely reliable and error-free, Phoenix Marketcity claims
          exemption from any liability arising out of any such error in the data
          base. Phoenix Marketcity provides documents that you are likely to use
          in legal or non-legal transactions. All forms in this database are
          provided without any warranty, express or implied, as to their legal
          effect and completeness. Forms should be used as a guide and modified
          to suit your requirement and laws. Please use at your own risk. Using
          application’s mail server for relay (producing spam mails) is
          prohibited. However if you get such unsolicited mails, Phoenix
          Marketcity accepts no responsibility.
          <br />
          <br />
          To protect against the loss, misuse and alteration of the information
          under our control, we have in place appropriate physical, electronic
          and managerial procedures. For example, our servers are accessible
          only to authorized personnel and that your information is shared with
          respective personnel on need to know basis to complete the transaction
          and to provide the services requested by you. Although we will
          endeavor to safeguard the confidentiality of your personally
          identifiable information, transmissions made by means of the Internet
          cannot be made absolutely secure. By using www.phoenixmarketcity.com
          you agree that we will have no liability for disclosure of your
          information due to errors in transmission or unauthorized acts of
          third parties.
        </p>
        <br />
        <br />
        <h3> The Information we collect: </h3>
        <p>
          The Websites are not set up to automatically collect personally
          identifiable information from each visitor to the Website. It does
          recognize the home server of visitors, but not e-mail addresses. For
          example, we can tell which Internet Service Provider our visitors use,
          but not the names, addresses or other information about our visitors
          that would allow us to identify a particular visitor to our Website.
          This information is used only for internal purposes by our technical
          support staff. The Website does track certain information about the
          visits to Phoenix Market City. For example, we compile statistics that
          show the numbers and frequency of visitors to the Website and its
          individual pages and time spent by each visitor on each page. These
          aggregated statistics are generally used internally to improve the
          Website and for product development and marketing purposes. Those
          aggregated statistics may also be provided to advertisers and other
          third parties, but again, the statistics contain no personal
          (specific) information and cannot be used to gather such information.
          This information may also be used to enable us to enhance your Site
          visit, to assist you with customer service or technical support
          issues, or to follow up with you after your visit, or to otherwise
          support your relationship with Phoenix Marketcity. It is completely
          optional for you to participate. However, failure to participate may
          mean that you cannot access and use certain information, materials and
          services.
          <br />
          <br />
          For example, we request information from you when you:
          <br />
          <br />
          Log-on to certain areas of the Website www.phoenixmarketcity.com where
          you may be prompted to provide us with your Log In Name and Password
          as a condition to gaining access to certain information, materials or
          services or support.
          <br />
          <br />
          Register or sign-up to use a service.
          <br />
          <br />
          Subscribe to a newsletter or desire to be added to our mailing lists
          for other products and services.
        </p>
        <ul>
          <li> Place an order. </li>
          <li> Provide feedback in an online survey.</li>
          <li> Contact us.</li>
          <li> Resume.</li>
          <li> Download destination. </li>
        </ul>
        <p>
          In each of the instances above, we typically ask for your name, e-mail
          address, phone number, address, area of practice information, product
          preference information, Log In Name and Password, as well as, other
          similar personal information that is needed to register or subscribe
          you to services or offers. On occasion, we may ask for additional
          information to enable us to provide you with access to and use of
          certain information, materials and services. If you no longer desire
          our service, you may correct, update, amend or request deletion by
          making the change on our account information page or by emailing
          customer support at customersupport@phoenixmarketcity.com.
        </p>
        <br />
        <br />
        <h3> How We Use Information</h3>
        <p>
          Phoenix Marketcity uses your personal information for specific
          purposes only. The personal information you provide to us when using
          the Website, such as your name, postal/ e-mail address or telephone
          number will be kept confidential and used to support your relationship
          with Phoenix Marketcity to notify you of special offers, updated
          information and new products and services from Phoenix Marketcity or
          offers from third parties that we think may be of interest to you.
          Agents or contractors of Phoenix Marketcity who are given access to
          your personal information will be required to keep the information
          confidential and not use it for any other purpose other than to carry
          out the services they are performing for Phoenix Marketcity may
          enhance or merge your information collected at its Website with data
          from third parties for purposes of marketing products or services to
          you. With respect to network advertising companies (companies that
          manage and provide advertising for numerous unrelated companies), to
          the extent that Phoenix Marketcity utilizes such advertising companies
          to provide advertisements on the Website Phoenix Marketcity may
          provide them with your Sign in Name and any demographic information
          about you that we collect. Those advertising companies may combine
          that data with non-personally identifiable data collected by the
          advertising company from your computer, solely for the purpose of
          delivering on our Website, advertisements that are targeted to you. If
          in case there are circumstances where we are required to disclose your
          personal information to third parties for purposes other than to
          support your customer relationship with Phoenix Market City, you deem
          to consent the same and in connection with a corporate divestiture or
          dissolution where we need to protect our assets in full or in portion
          of our business (including our associated customer lists containing
          your personal information), or if disclosure is required by law or is
          pertinent to judicial or governmental investigations or proceedings.
          We will send you information about our various products and services,
          or other products and services we feel may be of interest to you. We
          may also use the information to tailor our site to your interest, to
          provide the services requested by you, to preserve social history as
          governed by existing law or policy and conduct surveys. Only Phoenix
          Marketcity (or agents or contractors working on behalf of Phoenix
          Marketcity and under confidentiality agreements) will send you these
          direct mailings.
        </p>
        <br />
        <br />
        <h3> Revisions to this policy </h3>
        <p>
          {" "}
          Phoenix Marketcity reserves the right to revise, amend or modify this
          policy at any time and in any manner at its discretion.{" "}
        </p>

        <br />
        <br />
        <h3> Copyright </h3>
        <p>
          All material available on this website www.phoenixmarketcity.com is
          owned by “The Phoenix Mills Limited” and protected by copyright laws.
          Distribution of the material from the Website, for commercial purposes
          is strictly prohibited. Domestic copyright and Trademark laws protect
          the entire contents of the Site. The owners of the intellectual
          property, copyrights and trademarks are The Phoenix Mills Limited, its
          affiliates or third party licensors. You are expressly prohibited from
          modifying, copying, reproducing, republishing, uploading, posting,
          transmitting or distributing any material on this Site including text,
          graphics, code and/or software and shall not do any act to infringe
          the intellectual property, logos, mark etc. on this Website. You also
          agree that you shall not take recourse against Phoenix Marketcity for
          any alleged or actual infringement or misappropriation of any
          proprietary rights in your communications to Phoenix Marketcity. If
          you, at any stage believe that the contents appearing on this site
          constitutes copyright infringement of another person’s rights, please
          communicate the same to us forthwith. Phoenix Marketcity reserves the
          right to remove any content or links that allegedly infringes any
          other person’s copyright at any point of time. Notice to Phoenix
          Marketcity regarding any alleged copyright infringement shall be
          directed at:
          <br />
          <br />
          Phoenix Marketcity Bangalore,
          <br />
          Whitefield Main Road,
          <br />
          Mahadevpura, Bangalore – 560048
          <br />
          <br />
          Some contents on the site belong to third party. Such contents have
          been reproduced after taking prior permission from the said party and
          the copyright of such contents would remain exclusively with the said
          third party. Phoenix Marketcity shall not be responsible for any
          mistakes which might appear in such contents. Third party contents may
          also be accessible via links. Phoenix Marketcity does not claim any
          copyright on the contents appearing on such third party sites nor
          shall be held responsible for any mistakes which might appear therein
          access to Phoenix Marketcity services and content is subject to Terms
          and Conditions which you accepted during the registration process.
          These Terms and Conditions contain warranty disclaimers, guidelines
          for link to other websites & linking disclaimer and limitation on use.
          Phoenix Marketcity grants users of this website the permission to
          reproduce copies of the material strictly for private purposes to
          fight a case in the court of law and for allied research purposes.
          While no pecuniary consideration is required for this permission,
          Phoenix Marketcity requires the following statement to be included in
          all reproductions of the material.
          <br />
          <br />
          Phoenix Marketcity All rights reserved. Reprinted with the permission
          of Phoenix Marketcity.
          <br />
          <br />
          You are also not supposed to use any part of the material including
          graphics or logos available on the Phoenix Marketcity Website for the
          purpose of copying, photocopying, reproduction, translation or
          reduction to any electronic medium or machine readable form, either in
          whole or in part, without prior written consent of Phoenix Marketcity.
          Any other reproduction in any form without the permission of Phoenix
          Marketcity is prohibited.
          <br />
          <br />
          Intellectual Property Rights
          <br />
          Intellectual Property Rights (“IPR”) for the purpose of these Terms
          shall always mean and include copyrights whether registered or not,
          patents including rights of filing patents, trademarks, trade names,
          trade dresses, house marks, collective marks, associate marks and the
          right to register them, designs both industrial and layout,
          geographical indicators, moral rights, source code, technical data,
          broadcasting rights, displaying rights, distribution rights, selling
          rights, abridged rights, translating rights, reproducing rights,
          performing rights, communicating rights, adapting rights, circulating
          rights, protected rights, joint rights, reciprocating rights,
          infringement rights and further shall also include but not be limited
          to all text, graphics, user interfaces, visual interfaces, sounds and
          music (if any), artwork and computer code in relation to the Website.
          <br />
          <br />
          All IPR on the Website exclusively belong to either the Website or the
          third party sellers and suppliers, as the case may be. Under no
          circumstance shall any User infringe in any way such IPR of the
          Website, a third party supplier or Seller during or pursuant to its
          use of the Website for any purposes whatsoever.
          <br />
          <br />
          All those IPR arising as a result of domain names, internet or any
          other right available under applicable law shall vest in the domain of
          ___________________its affiliates as the owner of such domain name.
          <br />
          <br />
          The User hereto agrees and confirms that no part of any Intellectual
          Property rights mentioned hereinabove is transferred in the name of
          User and any intellectual property rights arising as a result of these
          presents shall also be in the absolute ownership, possession and our
          control or control of its owners/permitted assigns, as the case may
          be.
          <br />
          <br />
          Every User hereby grants the Company a perpetual, non-revocable,
          worldwide, royalty-free and sub-licensable right and license to use,
          copy, publish, transmit, reproduce, modify, adapt any content provided
          or created by the User. The Company shall have no liability for any
          infringement of intellectual property rights with respect to such
          content created by the User.
          <br />
          <br />
          Except as expressly provided herein, the User acknowledges and agrees
          that it shall not copy, republish, post, display, translate, transmit,
          reproduce or distribute or in any other way infringe any Intellectual
          Property Right through any medium without obtaining the necessary
          authorization from the Website or the thirty party owner of such
          Intellectual Property Right.
          <br />
          <br />
          The Services may contain content or services provided by third parties
          and/or links to third party services, websites or resources. We are
          not responsible or liable for the availability, accuracy,
          functionality, adherence to third party policies, or legality of, and
          we do not endorse, such websites, services or resources or the
          content, products, or services on or available from such websites or
          resources. You are solely responsible for and assume all risk arising
          from your use of any such websites, services or resources.
        </p>
        <br />
        <br />
        <h3> Website Limited License: </h3>
        <p>
          As a user of this Website you are granted a non-exclusive,
          non-transferable, revocable, limited license to access and use this
          Website for limited purpose and Content in accordance with these Terms
          of Use. Phoenix Marketcity may terminate this license at any time
          without any reason.
        </p>
        <br />
        <br />
        <h3>No Solicitation</h3>
        <p>
          You shall not distribute on or through this Website any content or
          material containing any advertising, promotion, solicitation for
          goods, services or funds or solicitation for others to become members
          of any enterprise or organization without the express written
          permission of the Phoenix Marketcity. Notwithstanding the foregoing,
          in any interactive areas of this Website, where appropriate, you:
        </p>
        <ul>
          <li>
            May list along with your name, address and email address, your own
            website’s URL.
          </li>
          <li>
            May recommend third party website s, goods or services so long as
            you have no financial interest in and receive no direct or indirect
            benefit from such recommended Website, product or service or its
            recommendation. In no event may any person or entity solicit anyone
            with data retrieved from this Website.
          </li>
        </ul>
        <br />
        <br />
        <h3> Advertisers </h3>
        <p>
          This Website may contain advertising and sponsorship. Advertisers and
          sponsors are responsible for ensuring that material submitted for
          inclusion on this Website is accurate and complies with applicable
          laws. Phoenix Marketcity will not be responsible for the illegality of
          or any error or inaccuracy in advertisers or sponsors materials or for
          the acts or omissions of advertisers and sponsors.
        </p>
        <br />
        <br />
        <h3> Registration</h3>
        <p>
          Certain sections of this Website require you to register. If
          registration is requested, you agree to provide Phoenix Marketcity
          with accurate and complete registration information. It is your
          responsibility to inform Phoenix Marketcity of any changes to that
          information. Each registration is for a single individual only, unless
          specifically designated otherwise on the registration page. Phoenix
          Marketcity does not permit:
        </p>
        <ul>
          <li>
            anyone other than you to use the sections requiring registration by
            using your name or password.
          </li>
          <li>
            access through a single name being made available to multiple users
            on a network or otherwise. You are responsible for preventing such
            unauthorized use. If you believe there has been an unauthorized use,
            you must notify Phoenix Marketcity immediately by emailing to
            customersupport@phoenixmarketcity.com
          </li>
        </ul>
        <br />
        <br />
        <h3>Postings to be Lawful </h3>
        <p>
          If you participate in interactive areas on this Website , you shall
          not post, publish, upload or distribute any messages, data,
          information, text, graphics, links or other material (“Postings”)
          which is unlawful or abusive in any way, including but not limited to
          any Postings that are defamatory, libelous, pornographic, obscene,
          threatening, invasive of privacy or publicity rights, inclusive of
          hate speech, or religious speech or would constitute or encourage a
          criminal offense, hurting religious sentiments of any caste or creed,
          violate the rights of any party, any other person or give rise to
          liability or violate any local, state, Central or international law.
        </p>
        <br />
        <br />
        <h3> Postings to be in Your Name </h3>
        <p>
          Any interactive area of this Website is provided solely for your
          personal use. As a participant, you shall not include in your
          posting(s) or otherwise distribute on or through this Website any
          content or material containing any advertising, promotion,
          solicitation for goods, services or funds or solicitation for anyone
          to become members of any commercial enterprise or organization without
          the express written permission of Phoenix Marketcity. Any
          unauthorized/commercial use of any interactive area of this Website,
          its Content or Postings is expressly prohibited.
        </p>
        <br />
        <br />
        <h3>Non-Commercial Use only of Interactive Areas </h3>
        <p>
          Your postings shall be accompanied by your real name and shall not be
          posted anonymously. Participants in interactive areas shall not
          misrepresent their identity or their affiliation with any person or
          entity.
        </p>
        <br />
        <br />
        <h3>No Monitoring of Postings</h3>
        <p>
          Phoenix Marketcity has no obligation nor does it intend to edit,
          monitor or screen postings and is not responsible for the content in
          such Postings or any content linked to or from such postings.
          Notwithstanding the foregoing Phoenix Marketcity reserves the right to
          examine from time to time, some, all, or no interactive areas for
          adherence to the Terms of Use and to remove any materials that may be
          objectionable, obscene or violating the Terms of Use.Unlawful Activity
          <br />
          <br />
          Phoenix Marketcity reserves the right to investigate complaints or
          reported violations of our Terms of Use/commercial use and to take any
          action deemed appropriate including but not limited to reporting any
          suspected unlawful activity to law enforcement officials, regulators,
          or other third parties and disclosing any information necessary or
          appropriate to such persons or entities relating to user profiles,
          e-mail addresses, usage history, posted materials, IP addresses and
          traffic information.
        </p>
        <br />
        <br />
        <h3>Governing Law and Jurisdiction</h3>
        <p>
          The Terms of Use are governed by and construed in accordance with the
          laws of India and any action arising out of or relating to these terms
          shall be filed only in Jurisdiction of the courts of Maharashtra and
          you hereby consent and submit to the jurisdiction of such
          courts.Intellectual Property
        </p>
      </div>
    </Fragment>
  );
};

export default TermsUse;
